// 新闻资讯+竞赛指导
<template>
  <div class="maxbox">
    <ul class="NewsList">
      <li
        v-for="item in data"
        :key="item.id"
        class="itemcard"
        @click="toInformation(item.id)"
      >
        <div class="uniimg"><img :src="item.pic" /></div>
        <div class="article">
          <div class="arttitle">{{ item.title }}</div>
          <div class="text-par">
            <vue-clamp :max-lines="2">
              {{ item.subtitle }}
            </vue-clamp>
          </div>
          <p class="text-time">{{ item.publishtime }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    data: {},
  },
  methods: {
    toInformation(uniid) {
      this.$emit("toInformation", uniid);
    },
  },
  created() {},
};
</script>
<style scoped>
.itemcard {
  cursor: pointer;
}
.maxbox {
  width: 100%;
  background: #f5f7fa;
  position: relative;
}
.NewsList {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.NewsList .uniimg {
  width: 300px;
  height: 225px;
  border: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-left: 20px;
}
.uniimg img {
  width: 300px;
  height: 225px;
  object-fit: cover;
}
.NewsList li {
  height: 265px;
  display: flex;
  box-sizing: border-box;
  background: #fff;
  margin: 10px 0px 20px 0px;
  text-align: left;
}
.NewsList li:nth-child(1) {
  margin-top: 33px;
}
.el-icon-more {
  display: none !important;
}

.article {
  width: 760px;
  display: block;
  margin-left: 40px;
  margin-top: 35px;
}
.arttitle {
  display: block;
  width: 771px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-par {
  font-size: 14px;
  display: -webkit-box;
  color: #666666;
  /* -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: pre-wrap;
  text-overflow: ellipsis; */
  width: 760px;
  height: 44px;
  margin-top: 33px;
  margin-bottom: 61px;
  line-height: 24px;
}
.text-par p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}

.text-time {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
</style>